'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var ipns = require('ipns');

var PeerId = require('peer-id');

var errCode = require('err-code');

var debug = require('debug');

var toString = require('uint8arrays/to-string');

var Errors = require('datastore-core/errors');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var ipns__namespace = /*#__PURE__*/_interopNamespace(ipns);

var PeerId__default = /*#__PURE__*/_interopDefaultLegacy(PeerId);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var Errors__namespace = /*#__PURE__*/_interopNamespace(Errors);

var log = Object.assign(debug__default["default"]('ipfs:ipns:resolver'), {
  error: debug__default["default"]('ipfs:ipns:resolver:error')
});
var ERR_NOT_FOUND = Errors__namespace.notFoundError().code;
var defaultMaximumRecursiveDepth = 32;

var IpnsResolver = /*#__PURE__*/function () {
  function IpnsResolver(routing) {
    _classCallCheck(this, IpnsResolver);

    this._routing = routing;
  }

  _createClass(IpnsResolver, [{
    key: "resolve",
    value: function () {
      var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name) {
        var options,
            recursive,
            nameSegments,
            key,
            depth,
            res,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

                if (!(typeof name !== 'string')) {
                  _context.next = 3;
                  break;
                }

                throw errCode__default["default"](new Error('invalid name'), 'ERR_INVALID_NAME');

              case 3:
                recursive = options.recursive && options.recursive.toString() === 'true';
                nameSegments = name.split('/');

                if (!(nameSegments.length !== 3 || nameSegments[0] !== '')) {
                  _context.next = 7;
                  break;
                }

                throw errCode__default["default"](new Error('invalid name'), 'ERR_INVALID_NAME');

              case 7:
                key = nameSegments[2];
                depth = Infinity;

                if (recursive) {
                  depth = defaultMaximumRecursiveDepth;
                }

                _context.next = 12;
                return this.resolver(key, depth);

              case 12:
                res = _context.sent;
                log("".concat(name, " was locally resolved correctly"));
                return _context.abrupt("return", res);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function resolve(_x) {
        return _resolve.apply(this, arguments);
      }

      return resolve;
    }()
  }, {
    key: "resolver",
    value: function () {
      var _resolver = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, depth) {
        var errMsg, res, nameSegments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(depth === 0)) {
                  _context2.next = 4;
                  break;
                }

                errMsg = "could not resolve name (recursion limit of ".concat(defaultMaximumRecursiveDepth, " exceeded)");
                log.error(errMsg);
                throw errCode__default["default"](new Error(errMsg), 'ERR_RESOLVE_RECURSION_LIMIT');

              case 4:
                _context2.next = 6;
                return this._resolveName(name);

              case 6:
                res = _context2.sent;
                nameSegments = res.split('/');

                if (!(nameSegments[1] === 'ipfs' || !depth)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", res);

              case 10:
                return _context2.abrupt("return", this.resolver(nameSegments[2], depth - 1));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function resolver(_x2, _x3) {
        return _resolver.apply(this, arguments);
      }

      return resolver;
    }()
  }, {
    key: "_resolveName",
    value: function () {
      var _resolveName2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(name) {
        var peerId, _ipns__namespace$getI, routingKey, record, ipnsEntry;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                peerId = PeerId__default["default"].parse(name);
                _ipns__namespace$getI = ipns__namespace.getIdKeys(peerId.toBytes()), routingKey = _ipns__namespace$getI.routingKey;
                _context3.prev = 2;
                _context3.next = 5;
                return this._routing.get(routingKey.uint8Array());

              case 5:
                record = _context3.sent;
                _context3.next = 14;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);
                log.error('could not get record from routing', _context3.t0);

                if (!(_context3.t0.code === ERR_NOT_FOUND)) {
                  _context3.next = 13;
                  break;
                }

                throw errCode__default["default"](new Error("record requested for ".concat(name, " was not found in the network")), 'ERR_NO_RECORD_FOUND');

              case 13:
                throw errCode__default["default"](new Error("unexpected error getting the ipns record ".concat(peerId.toString())), 'ERR_UNEXPECTED_ERROR_GETTING_RECORD');

              case 14:
                _context3.prev = 14;
                ipnsEntry = ipns__namespace.unmarshal(record);
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t1 = _context3["catch"](14);
                log.error('could not unmarshal record', _context3.t1);
                throw errCode__default["default"](new Error('found ipns record that we couldn\'t convert to a value'), 'ERR_INVALID_RECORD_RECEIVED');

              case 22:
                return _context3.abrupt("return", this._validateRecord(peerId, ipnsEntry));

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 8], [14, 18]]);
      }));

      function _resolveName(_x4) {
        return _resolveName2.apply(this, arguments);
      }

      return _resolveName;
    }()
  }, {
    key: "_validateRecord",
    value: function () {
      var _validateRecord2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peerId, ipnsEntry) {
        var pubKey;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return ipns__namespace.extractPublicKey(peerId, ipnsEntry);

              case 2:
                pubKey = _context4.sent;
                _context4.next = 5;
                return ipns__namespace.validate(pubKey, ipnsEntry);

              case 5:
                return _context4.abrupt("return", toString.toString(ipnsEntry.value));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function _validateRecord(_x5, _x6) {
        return _validateRecord2.apply(this, arguments);
      }

      return _validateRecord;
    }()
  }]);

  return IpnsResolver;
}();

exports.IpnsResolver = IpnsResolver;